import React from "react";
import { courseIncludes, loremData } from "../../../_constants/staticData";
import { useTranslation } from "react-i18next";
import CourseTile from "../CourseTile/CourseTile";
import { Link } from "react-router-dom";
import { buildCourseDetailsURI } from "../../../_helpers";

const relatedCourses = [
  {
    imageLink:
      `${process.env.REACT_APP_SMIK_API_BASEURL}/courses/2528/de3d968f-0f08-4383-8fe1-3278e996ae15.png`,
    name: "Javascript Bundle",
    price: 25,
    bundleOneLiner: null,
    id: 111111111111111111111
  },
  {
    imageLink:
      `${process.env.REACT_APP_SMIK_API_BASEURL}/courses/2528/de3d968f-0f08-4383-8fe1-3278e996ae15.png`,
    name: "Javascript Bundle",
    price: 25,
    bundleOneLiner: null,
    id: 222222222222222222222
  },
];

const BundleChapterOverView = ({ bundleDetails }) => {
  const { t } = useTranslation();
  return (
    <div className="inner-div">
      <div className="main-cart-course">
        <div className="course-cart-left">
          <div className="section-title">{t("in a snapshot")}</div>
          <div className="snap-bundle">
            <div>
              <p>Duration</p>
              <p className="snap-bundle-para">
                {bundleDetails?.duration === null ? 0 : bundleDetails?.duration}
                Hrs
              </p>
            </div>
            <div>
              <p>Certification</p>
              <p className="snap-bundle-para">Yes</p>
            </div>
            <div>
              <p>Learning Type</p>
              <p className="snap-bundle-para">Self Paced</p>
            </div>
            <div>
              <p>Language</p>
              <p className="snap-bundle-para">English</p>
            </div>
            <div>
              <p>Video Transcripts</p>
              <p className="snap-bundle-para">Available</p>
            </div>
          </div>
          <div className="snap-span">
            This Course Bundle is also Available with a Subscription.
            {/* <span>Find out more</span> */}
          </div>

          <div className="course-page-section style-margin-top">
            <div className="section-title">{t("Bundle Description")}</div>
            <div>
              <p
                dangerouslySetInnerHTML={{
                  __html: bundleDetails.description,
                }}
              ></p>
            </div>
          </div>

          <div className="style-margin-top">
            <div className="section-title">
              {t("This Course Bundle Includes")}
            </div>
            {bundleDetails.courses.length > 0 && (
              <div>
                {bundleDetails?.courses?.map((ele, item) => (
                  <div className="bundle-flex-1" key={item}>
                    <Link
                      aria-label="Course Details"
                      to={buildCourseDetailsURI(
                        ele.Category,
                        ele.CourseName,
                        ele.ID
                      )}
                    >
                      {ele.CourseName}
                    </Link>
                    <img src="https://www.pngfind.com/pngs/m/683-6838012_transparent-link-clipart-external-link-icon-white-hd.png"  loading="lazy" />
                  </div>
                ))}
              </div>
            )}
          </div>

          {bundleDetails?.preRequisites[0]?.length > 0 && (
            <div className="style-margin-top">
              <div className="section-title">{t("Bundle Requirements")}</div>
              <ul>
                {bundleDetails?.preRequisites[0].map((course, index) => {
                  return <li key={index}>{course.name}</li>;
                })}
              </ul>
            </div>
          )}
          <div className="style-margin-top">
            <div className="section-title">{t("Bundle Goals")}</div>
            <ul>
              {bundleDetails?.goals[0]?.map((post, index) => (
                <div key={index} className="">
                  <li>{post.name}</li>
                </div>
              ))}
            </ul>
          </div>

          {bundleDetails?.faqs[0] && bundleDetails?.faqs[0]?.length > 0 && (
            <>
              <div className="course-page-section style-margin-top">
                <div className="section-title">{t("Bundle FAQs")}</div>
                {bundleDetails.faqs[0] &&
                  bundleDetails.faqs[0].map((course, index) => (
                    <div key={index} className="section-para">
                      <h4>
                        {index + 1}. {course.question}
                      </h4>
                      <p>{course.answer}</p>
                    </div>
                  ))}
              </div>
            </>
          )}

          {/* <div className="style-margin-top">
            <div className="section-title">{t("benefits of this bundle")}</div>
            <div className="bundle-flex">
              <div>
                <p>
                  <span style={{ color: "#6805a0" }}>&#10003;</span> Lorem ipsum
                  dolor sit amet consectetur adipisicing elit. Deserunt animi
                  delectus fugiat tempore veritatis obcaecati.
                </p>
                <p>
                  <span style={{ color: "#6805a0" }}>&#10003;</span> Lorem ipsum
                  dolor sit amet consectetur adipisicing elit. Deserunt animi
                  delectus fugiat tempore veritatis obcaecati.
                </p>
              </div>
              <div>
                <p>
                  <span style={{ color: "#6805a0" }}>&#10003;</span> Lorem ipsum
                  dolor sit amet consectetur adipisicing elit. Deserunt animi
                  delectus fugiat tempore veritatis obcaecati.
                </p>
              </div>
            </div>
          </div> */}
          {/* <div className="style-margin-top">
            <div className="section-title">{t("prerequisites")}</div>
            <div>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Deserunt animi delectus fugiat tempore veritatis obcaecati.
                Dolores eos earum debitis, est nihil iure perspiciatis esse ex
                odio a impedit nisi aspernatur cupiditate, consequatur
                doloremque sint veritatis voluptas! Eum sed cumque nemo saepe
                laboriosam maiores consectetur velit?
              </p>
            </div>
          </div> */}

          {/* <div className="style-margin-top">
            <div className="section-title">{t("bundle faq")}s</div>
            <div className="section-para">
              <h4>What is React ?</h4>
              <p>
                Lorem, ipsum dolor sit amet consectetur adipisicing elit. Quasi
                vel aliquam eligendi? Doloribus adipisci reiciendis quam est.
                Est, neque magnam aut mollitia atque possimus quos omnis impedit
                veniam at expedita.
              </p>
            </div>
          </div> */}
          <div className="style-margin-top">
            <div className="related-course">
              <div className="front-panel">
                <div className="courseList">
                  <div className="section-title">Related Bundles</div>
                  <div className="tile-column">
                    {relatedCourses &&
                      relatedCourses.length > 0 &&
                      relatedCourses.map((post, index) => (
                        <CourseTile
                          key={index}
                          post={{ ...post, ID: post.id }}
                          bundle={true}
                          demo={true}
                        />
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="course-cart-right">
          <div className="edged-wrapper">
            <div className="right-side-header">{t("Includes")}</div>
            <div className="right-sider-icons-div">
              <ul>
                {/* <li>
                  <span> of video material</span>
                </li> */}
                <li>
                  <span>{courseIncludes.key1}</span>
                </li>
                <li>
                  <span> {courseIncludes.key2}</span>
                </li>
                <li>
                  <span> {courseIncludes.key3}</span>
                </li>
                <li>
                  <span> {courseIncludes.key4}</span>
                </li>
                <li>
                  <span> {courseIncludes.key5}</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="right-question-btn"></div>
        </div>
      </div>
    </div>
  );
};

export default BundleChapterOverView;
